import { render, staticRenderFns } from "./OwnerRigest.vue?vue&type=template&id=c04071da&"
import script from "./OwnerRigest.vue?vue&type=script&lang=js&"
export * from "./OwnerRigest.vue?vue&type=script&lang=js&"
import style0 from "./OwnerRigest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports